(function($) {
	$(document).ready(function(){
		var $slider = $('.slider__slides');
		var $slides = $( '.slider__slide', $slider);
		var counter = 1;
		var slideCount = $slides.length - 1;
		$slides.eq(0).addClass('active');
		setInterval(function(){
			$slides.eq(counter-1).removeClass('active');
			$slides.eq(counter).addClass('active');
			if(counter === slideCount) {
				counter = 0;
			} else {
				counter++;
			}
		}, 3000);
	});
})(jQuery);